import {Client} from "@/endpoints/rutsolve/gql/resolvers/client"
import {
    SessionRolesDocument,
    StartSessionDocument,
    StartSessionQueryVariables,
} from "@/endpoints/rutsolve/gql/generated/graphql"

export class Session extends Client {
    constructor() {
        super()
    }

    public async start(id: string, secret: string): Promise<string> {
        try {
            const variables: StartSessionQueryVariables = {
                id: id,
                secret: secret,
            }
            const response = await this.client.request(StartSessionDocument, variables)
            return response.startSession
        } catch (error) {
            this.handleError(error)
        }
    }

    public async roles(): Promise<string[]> {
        try {
            const response = await this.client.request(SessionRolesDocument)
            return response.sessionRoles
        } catch (error) {
            this.handleError(error)
        }
    }
}
